import React from 'react';
import './AboutProxima.css';
import ProximaText from './AboutProximaText';

const AboutProxima = ({ onClose }) => {
    return (
        <div className="about-popup-overlay">
            <div className="about-popup-container">
                <button className="about-close-button" onClick={onClose}>{'\u00D7'}</button>
                <div className="about-popup-content">
                    <ProximaText />
                </div>
            </div>
        </div>
    );
};

export default AboutProxima;